import { Chip } from "@heroui/react";
import type { TokenDetails } from "../../queries/tokenReg";
import { TokenProposalStatus } from "../../queries/tokenReg";

export function TokenRegistrationProgress({ tokenData }: { tokenData: TokenDetails }) {
  if (tokenData.l1RegistrationStatus && tokenData.l2RegistrationStatus) {
    return (
      <Chip variant="flat" radius="sm" size="sm" className="bg-[#36CC36]/20 text-[#36CC36]">
        Registered
      </Chip>
    );
  }

  switch (tokenData.l1ProposalStatus) {
    case TokenProposalStatus.UNKNOWN:
      return (
        <Chip variant="flat" radius="sm" size="sm" color="default">
          Unknown
        </Chip>
      );
    case TokenProposalStatus.REJECTED:
      return (
        <Chip variant="flat" radius="sm" size="sm" color="danger">
          Rejected
        </Chip>
      );
    case TokenProposalStatus.PROPOSED:
      return (
        <Chip variant="flat" radius="sm" size="sm" className="bg-[#F6851B]/20 text-[#F6851B]">
          In Progress
        </Chip>
      );
    case TokenProposalStatus.ACCEPTED:
      return (
        <Chip variant="flat" radius="sm" size="sm" className="bg-[#F6851B]/20 text-[#F6851B]">
          Action Required
        </Chip>
      );
  }
}
